import { Box, IconButton } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import style from "./mobile-navigation-header.scss";
import { SidebarToggle } from "components/icons/SidebarToggle";
import { Logo } from "components/logo/Logo";
import { StoreState } from "store";
import { Application } from "store/application";
import { resolveColor } from "utils/commonFunctions";
import { useIsDarkThemeActive } from "utils/useTheme";

import testIds from "testIds.json";

interface Props {
    isNavigationOpen: boolean;
    onToggle: () => void;
    isTenantBannerVisible: boolean;
}

export const MobileNavigationHeader = (props: Props) => {
    const application = useSelector((state: StoreState) => state.applicationReducer.selected);
    const isDarkMode = useIsDarkThemeActive();

    return (
        <Box
            justifyContent="SpaceBetween"
            className={classNames(style.mobileNavigationHeader, {
                ["tenantBannerVisible"]: props.isTenantBannerVisible,
            })}
            testId={testIds.navigation.mobileNavigationHeader.itself}
        >
            <Box verticalAlignment="Center">
                <Link to="/" data-testid={testIds.navigation.mobileNavigationHeader.defaultLink}>
                    <Logo width={135} height={36} isWhiteLogo={application !== Application.BAM || isDarkMode} />
                </Link>
            </Box>

            <Box verticalAlignment="Center">
                <IconButton
                    size="Md"
                    onClick={props.onToggle}
                    data-testid={testIds.navigation.mobileNavigationHeader.toggleButton}
                >
                    <SidebarToggle
                        color={
                            application === Application.BAM
                                ? resolveColor("--app-navigationPanel-iconColor")
                                : resolveColor("--theme-icon-fill-white")
                        }
                        rotate={!props.isNavigationOpen}
                    />
                </IconButton>
            </Box>
        </Box>
    );
};
